import { ModuleWithProviders, NgModule } from '@angular/core';
import { AreaOfUseAdminStoreModule } from './store/area-of-use-admin-store.module';

@NgModule({
  imports: [AreaOfUseAdminStoreModule],
})
export class AreaOfUseAdminBaseModule {
  static forRoot(): ModuleWithProviders<AreaOfUseAdminBaseModule> {
    return {
      ngModule: AreaOfUseAdminBaseModule,
    };
  }
}
